import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchLogs, fetchLogsTableColumnNames } from "../../../slices/logs/thunk";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import usePermissions from "../../../Components/Hooks/usePermissions";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";

function Logs() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {user} = getAuthUser();
  const [searchTerm, setSearchTerm] = useState("");


  const { logs, loading, error, tableColumnNames, module } = useSelector((state) => ({
    logs: state.Logs.logs,  
    loading: state.Logs.loading,
    error: state.Logs.error,
    tableColumnNames: state.Logs.tableColumnNames,
    module: state.Module.module,
  }));

    // Compute permission
  const permission = (() => {
    return usePermissions(1, 5);
  })();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchLogsTableColumnNames({ module: "LOG"})).unwrap();
        await dispatch(fetchLogs());
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [dispatch, user.UserId]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("Logs")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
              <Row className="g-4 ">
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
              </Row>
            </CardHeader>

            <CardBody>
           
              {loading ? (
                <div className="d-flex justify-content-center align-items-center">
                 <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                  Loading...
                 </Spinner>
                </div>
              ) : (
                <div className="listjs-table" id="customerList">
                  {/* <CommonTable
                    data={logs}
                    tableColumnNames={tableColumnNames}
                    searchTerm={searchTerm}
                    hasAction={false}
                  /> */}
                  <CommonDataTable
                    data={logs}
                    tableColumnNames={tableColumnNames}
                    searchTerm={searchTerm}
                    permission={permission}
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </Container>
    </div>
  );
}

export default Logs;
